import {Box, IconWithText, Text} from 'exsportia-components'
import {IconWithTextProps} from 'exsportia-components/dist/components/molecules/icon-with-text'
import {IconType, TextType} from 'exsportia-components/dist/types'
import React, {memo, useMemo} from 'react'

import {TranslatorScope} from '../../../locale/types'
import {useLocale} from '../../../utils/i18n'
import {SessionAvailabilitySubtitle} from '../../session-availability-subtitle/session-availability-subtitle'
import {defaultSettings} from '../settings'

type Props = {
  instructorName: TextType
  instructorImage?: IconType
  availableSpots: number
  iconWithTextAdditionalStyles: IconWithTextProps['additionalStyles']
  disabledText?: TranslatorScope
  variant?: 'waitingListBooked' | 'waitingListAvailable' | 'default'
  selected?: boolean
}

const notificationTextSettings = {
  fontSize: 'label',
  lineHeight: '20px',
  color: 'notify',
}

export const InstructorSection = memo<Props>(
  ({instructorName, instructorImage, availableSpots, iconWithTextAdditionalStyles, disabledText, variant, selected}) => {
    const {l} = useLocale()
    const isWaitingListAvailable = variant === 'waitingListAvailable'
    const isWaitingListBooked = variant === 'waitingListBooked'

    const subTextMarkup = useMemo(() => {
      if (isWaitingListBooked) {
        return (
          <Text
            text={l('waitingListBooked' as any) || 'Waiting List Booked'}
            settings={{
              ...notificationTextSettings,
              color: 'text-secondary',
            }}
          />
        )
      }
      if (isWaitingListAvailable) {
        return (
          <Text
            text={l('fullJoinWaitingList' as any) || 'Full. Join a waiting list'}
            settings={notificationTextSettings}
          />
        )
      }
      if (disabledText) {
        return (
          <Text
            text={l(disabledText, {caseAction: 'capitalize'})}
            settings={notificationTextSettings}
          />
        )
      }
      return <SessionAvailabilitySubtitle availableSpots={availableSpots} selected={selected} />
    }, [isWaitingListBooked, isWaitingListAvailable, disabledText, availableSpots, l, selected])

    const instructorSettings = selected
      ? {...defaultSettings.instructor, title: {...defaultSettings.instructor.title, color: 'white'}}
      : defaultSettings.instructor

    return instructorName && instructorImage ? (
      <IconWithText
        icon={
          <Box
            backgroundSize='cover'
            height='32px'
            width='32px'
            background={`url(${instructorImage}) no-repeat center`}
          />
        }
        title={instructorName}
        subText={subTextMarkup}
        settings={instructorSettings}
        additionalStyles={iconWithTextAdditionalStyles}
      />
    ) : (
      <Box height={'32px'}>{subTextMarkup}</Box>
    )
  },
)
